// extracted by mini-css-extract-plugin
export default {"info":"style_info__nCylo","eventTitle":"style_eventTitle__dwYLH","dateInscription":"style_dateInscription__UtNrl","section":"style_section__NZvjs"};